import _ from 'lodash';
import * as actions from 'app/actions/legal';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_LEGAL_PAGES: {
      return Object.assign({}, state, {
        termsOfServicePage: {
          ..._.find(action.result, { fields: { type: 'termsOfService' } }).fields,
          minorVersion: _.find(action.result, { fields: { type: 'termsOfService' } }).sys.revision,
        },
      });
    }
    case actions.SET_TOS_PAGE: {
      return Object.assign({}, state, {
        termsOfServicePage: {
          ..._.find(action.result, { fields: { type: 'termsOfService' } }).fields,
          minorVersion: _.find(action.result, { fields: { type: 'termsOfService' } }).sys.revision,
        },
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/legal.js